import { Box, Button, Typography } from '@mui/material';
import { LockOutlined, ArrowBack, Home } from '@mui/icons-material';
import { Title, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';

interface AccessDeniedPageProps {
  requiredPermission?: string;
}

export const AccessDeniedPage = ({ requiredPermission }: AccessDeniedPageProps) => {
  const translate = useTranslate();
  const navigate = useNavigate();

  return (
    <>
      <Title title={translate('accessDenied.title', { _: 'Access Denied' })} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 200px)',
          px: 2,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 96,
            height: 96,
            borderRadius: '50%',
            backgroundColor: '#FFEBEE',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <LockOutlined sx={{ fontSize: 48, color: '#FF3D00' }} />
        </Box>
        <Typography sx={{ fontSize: { xs: '1.5rem', sm: '2rem' }, fontWeight: 700, color: '#1A1A1A', mb: 1 }}>
          {translate('accessDenied.title', { _: 'Access Denied' })}
        </Typography>
        <Typography variant="body1" sx={{ color: '#606060', mb: 1, maxWidth: 480 }}>
          {translate('accessDenied.description', {
            _: "You don't have permission to access this page. Contact your administrator if you believe this is a mistake.",
          })}
        </Typography>
        {requiredPermission && (
          <Typography
            variant="caption"
            sx={{
              color: '#909090',
              mb: 3,
              fontFamily: 'monospace',
              backgroundColor: '#F5F5F5',
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
            }}
          >
            {translate('accessDenied.requiredPermission', { _: 'Required permission' })}: {requiredPermission}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{ borderColor: '#DDD', color: '#606060' }}
          >
            {translate('accessDenied.goBack', { _: 'Go back' })}
          </Button>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/')}
            sx={{ backgroundColor: '#009A75', '&:hover': { backgroundColor: '#00875F' } }}
          >
            {translate('accessDenied.goHome', { _: 'Go to home' })}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AccessDeniedPage;
